import React from 'react';
import discover from 'assets/images/discover.svg';
import { SvgIconProps } from '@mui/material';

export const AfDiscoverIcon: React.FC<SvgIconProps> = () => {
  return <img src={discover} />;
};
